import styled, { css } from 'styled-components';

export const HintWrapper = styled.div`
  text-align: center;
  margin-top: 0.5rem;
  border-radius: 6px;
  background: #ffffff;
  border-radius: 24px 24px 24px 0px;
  opacity: 0.9;
  padding: 0 1rem;
  font-weight: 500;
  text-align: left;
  max-height: 98px;
  overflow: auto;
  overflow: overlay;
  display: flex;
  gap: 0.5rem;
  word-break: break-word;
  &::-webkit-scrollbar {
    width: 0.7rem;
  }
  &::-webkit-scrollbar-track {
    border-radius: 60px;
    background-color: var(--scrollbar-bg-color);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-thumb-color);
    border-radius: 60px;
  }
`;

export const IconWrapper = styled.div`
  padding-top: 0.5rem;
`;

export const HintText = styled.div`
  max-width: 245px;
`;
